import React, { useEffect, useRef, useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "../histroricFlights/historic.css";
import "./flightLiveTracking.css"
import { useForm, Controller, set } from "react-hook-form";
import CustomDOBPicker from "../../components/CustomDOBPicker";
import axios from "axios";
import base_url from "../../api/bootapi";
import AsyncSelect from "react-select/async";
import CustomButton from "../../components/CustomButton";
import moment from "moment";
import FlightIcon from "../../assets/flight-two.png";


import { Loader, Radio, Tabs } from "@mantine/core";
import { Link } from "react-router-dom";
import {
  IconPlaneArrival,
  IconPlaneDeparture,
  IconRotateClockwise,
  IconTemperatureSun,
} from "@tabler/icons-react";
import { Flight } from "@mui/icons-material";
import FlightMap from "./FlightMap";

const FlightLiveTracking = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      airline: "",
      flightNumber: "",
      departureDate: null,
    },
  });

  const [defaultAirlineOptions, setDefaultAirlineOptions] = useState([]);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [flightData, setFlightData] = useState([]);
  const [airports, setAirports] = useState([]);
  const [currentFlightPosition, setCurrentFlightPosition] = useState([]);
  const [heading, setHeading] = useState(0);
  const [departureCode, setDepartureCode] = useState(null);
  const [arrivalCode, setArrivalCode] = useState(null);

     const [searchBy,setSearchBy]=useState('airline_name')
  

  const [flightDetails,setFlightDetails]=useState(null)

  const [loading, setLoading] = useState(false);

  const [requestData, setRequestData] = useState(null);
  const [upcomingDates, setUpcomingDates] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
const [positions,setPositions]=useState([])
  const renderValue = value => {
    if (value === "" || value === null || value === undefined) {
      return null
    } else {
      return value
    }
  }

  const onSubmit = async (data) => {
    setLoading(true);
    console.log("Submitted Data:", data);
    console.log(moment(data.departureDate).format("YYYY-MM-DD"));
    console.log(typeof data.departureDate);
    const requestData = {
      airline_code: data.airline.hub_code,
      flight_number: data.flightNumber,
      flight_date: moment(data.departureDate, "MM-DD-YYYY").format(
        "YYYY-MM-DD"
      ),
    };

    setRequestData(requestData);

    fetchFlightData(requestData);
  };

  const [toAirport, setToAirport] = useState([]);
  const [fromAirport, setFromAirport] = useState([]);
  const [flightStatus, setFlightStatus] = useState(null);

  function getDates(dateString) {
    const result = [];
    const [month, day, year] = dateString.split("-").map(Number);

    let date = new Date(year, month - 1, day); // month is 0-indexed

    for (let i = -3; i <= 1; i++) {
      let newDate = new Date(date);
      newDate.setDate(date.getDate() + i);
      let formatted =
        String(newDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(newDate.getDate()).padStart(2, "0") +
        "-" +
        newDate.getFullYear();
      result.push(formatted);
    }

    return result;
  }

  // useEffect(() => {
  //   if (airports.length > 0) {
  //     const toAirportIndex = airports.find(
  //       (airport) => airport.fs === arrivalCode
  //     );

  //     console.log("toAirportIndex", toAirportIndex);
  //     console.log("arrivalCode", arrivalCode);

  //     const fromAirportIndex = airports.find(
  //       (airport) => airport.fs === departureCode
  //     );

  //     if (toAirportIndex) {
  //       setToAirport(toAirportIndex);
  //     }

  //     if (fromAirportIndex) {
  //       setFromAirport(fromAirportIndex);
  //     }

  //     console.log("fromAirportIndex", fromAirportIndex);
  //     console.log("departureCode", departureCode);
  //   }
  // }, [airports]);

  const tabsListRef = useRef(null);
  const activeTabRef = useRef(null);

  useEffect(() => {
    if (activeTabRef.current) {
      activeTabRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [activeTab]);

  const handleChangeTab = (value) => {
    setActiveTab(value);

    if (requestData) {
      const { airline, flightNumber, departureDate } = requestData;
      const data = {
        airline: airline,
        flightNumber: flightNumber,
        departureDate: value,
      };

      fetchFlightData(data, true);
    }
  };

  console.log(toAirport);
  console.log(fromAirport);
  const getFlightDurationHours = (seconds) => {
    if (!seconds || seconds === undefined || seconds === "") {
      return ""
    }
  const hours = Math.floor(seconds / 3600);          // total hours
  const minutes = Math.floor((seconds % 3600) / 60); // remaining minutes
  return <> <b>{hours}hr {minutes}m</b> total travel time</> ;

  }
const [refreshing,setRefresing]=useState(false)
  const handleRefresh = async () => {
    setRefresing(true)

    await fetchFlightData(requestData);

    setRefresing (false)
  }
  const fetchFlightData = async (data, fromTab = false) => {
    try {
      const response = await axios.post(
        `${base_url.api1}/tourapp/flightaware_live_track`,data
      );
      //console.log("triggerFrom 204", triggerFrom);

      console.log("response", response);
      // if (!fromTab) {
      //   setUpcomingDates(getDates(data.departureDate));
      //   setActiveTab(data.departureDate);
      // }


       
      console.log(response?.data)
      const flightData = response?.data?.Flight[0];
      console.log(flightData)

      const departureAirport = flightData?.origin
      const arrivalAirport = flightData?.destination
      const departureTerminal = flightData?.terminal_origin
      const arrivalTerminal = flightData?.terminal_destination
      const departureGate = flightData?.gate_origin
      const arrivalGate = flightData?.gate_destination
      const departureDate = flightData?.estimated_out || flightData?.estimated_off || flightData?.actual_out || flightData?.actual_off || flightData?.scheduled_out ||flightData?.scheduled_off
      const arrivalDate = flightData?.estimated_in || flightData?.estimated_on|| flightData?.actual_in || flightData?.actual_on || flightData?.scheduled_in || flightData?.scheduled_on
      const status = flightData?.status
      const progress = flightData?.progress_percent
      const flightNumber=flightData?.operator_iata+flightData?.flight_number

      const map = flightData?.map?.map
      const arrivalDelay = flightData?.arrival_delay;
      const departureDelay = flightData?.departure_delay;
      const duration = flightData?.filed_ete || null;


      const positions = flightData?.live?.positions
      setPositions(positions)

      setCurrentFlightPosition(positions)



      const flightDetails = {
        fromAirport: {...departureAirport,terminal:departureTerminal,date:departureDate,gate:departureGate,delay:departureDelay},
        toAirport: {...arrivalAirport,terminal:arrivalTerminal,date:arrivalDate,gate:arrivalGate,delay:arrivalDelay},
        status: status,
        progress: progress,
        map: map,
        flightNumber,
        duration
      } 

      setFlightDetails(flightDetails)


      console.log(flightDetails)

     



      

   

   
      // console.log(response.data.airlines.flightTracks[0].arrivalAirportFsCode);
      // const currentFlightPosition =
      //   response.data?.airlines?.flightTracks[0]?.positions;
      // const heading = response.data?.airlines?.flightTracks[0]?.heading || 0;

      // setHeading(heading);

      // setCurrentFlightPosition(currentFlightPosition);
      setLoading(false);
    } catch (error) {
     setFlightDetails(null)
      setLoading(false);
      console.error("Error fetching flight options:", error);
    }
  };

  const validateDateFormat = (value) => {
    const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    // Check format
    if (!ddmmyyyy.test(value) && !yyyymmdd.test(value)) {
      return "Date must be in dd-mm-yyyy format";
    }

    return true;
  };

  const loadAirlineOptions = (inputValue, callback) => {
    fetchAirlines(inputValue).then((options) => callback(options));
  };

  const fetchAirlines = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
                  `${base_url.api1}/tourapp/flight_states_airlines?${searchBy}=${inputValue}`

        );
        if (response.data && response.data.Airlines) {
          return response.data.Airlines.map((airline) => ({
            value: airline.id,
            label: `${airline.airline_name} ${
              airline.iata_code ? `(${airline.iata_code})` : ""
            }`,
            hub_code: airline.icao_code,
          }));
        }
      } catch (error) {
        console.error("Error fetching airlines:", error);
      }
    }
    return [];
  };

  const fetchInitialAirports = async () => {
    try {
      // Fetch initial airline options
      const airlineResponse = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airlines?sortby=airline_name`
      );
      if (airlineResponse.data && airlineResponse.data.Airlines) {
        const airlineOptions = airlineResponse.data.Airlines.map((airline) => ({
          value: airline.id,
          label: `${airline.airline_name} ${
            airline.iata_code ? `(${airline.iata_code})` : ""
          }`,
          hub_code: airline.iata_code,
        }));
        setDefaultAirlineOptions(airlineOptions);
      }

      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`
      );
      if (response.data && response.data.Airports) {
        const options = response.data.Airports.map((airport) => ({
          value: airport.id,
          label: `${airport.airport_name.replace(
            /[\n\u0000-\u001F\u007F-\u009F]/g,
            ""
          )} (${airport.iata_code})`,
        }));

        setDefaultOptions(options);
      }
    } catch (error) {
      console.error("Error fetching initial airports:", error);
    }
  };

  useEffect(() => {
    fetchInitialAirports();
  }, []);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "none !important",
      outline: "none !important",
      border: "none !important",
      boxShadow: "none !important",
      // width: "280px",
      // maxWidth: "280px",
      // minWidth: "280px",

      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
        ? "#f0f0f0"
        : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
  };

  const utcDateFormat = (dateString) => {
    if (!dateString) return "";
    const dateObj = new Date(dateString);
    const dateOptions = {
      weekday: "long",
      day: "2-digit",

      month: "short",
      year: "numeric",
    };
    const formattedDate = dateObj.toLocaleDateString("en-GB", dateOptions);

    const hours = String(dateObj.getUTCHours()).padStart(2, "0");
    const minutes = String(dateObj.getUTCMinutes()).padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`; // "11:43"
    return {
      date: formattedDate,
      time: formattedTime,
    };
  };

// const dateFormat = (dateString, timeZone = "UTC") => {
//   if (!dateString) return "";

//   try {
//     const dateObj = new Date(dateString);

//     if (isNaN(dateObj)) return "";

//     // Weekday, day, month, year
//     const weekday = new Intl.DateTimeFormat("en-GB", { weekday: "long", timeZone }).format(dateObj);
//     const day = new Intl.DateTimeFormat("en-GB", { day: "2-digit", timeZone }).format(dateObj);
//     const monthName = new Intl.DateTimeFormat("en-GB", { month: "short", timeZone }).format(dateObj);
//     const year = new Intl.DateTimeFormat("en-GB", { year: "numeric", timeZone }).format(dateObj);

//     // Time (force 2 digits for hour + minute)
//     const hour = String(
//       new Intl.DateTimeFormat("en-GB", { hour: "2-digit", hour12: true, timeZone }).format(dateObj)
//     ).padStart(2, "0");

//     const minute = String(
//       new Intl.DateTimeFormat("en-GB", { minute: "2-digit", timeZone }).format(dateObj)
//     ).padStart(2, "0");

//     return {
//       date: `${weekday}, ${day} ${monthName} ${year}`,
//       time: `${hour}:${minute}`,
//     };
//   } catch (err) {
//     console.error("Invalid date or timezone", err);
//     return "";
//   }
//   };
  
  const dateFormat = (dateString, timeZone = "UTC") => {
  if (!dateString) return "";

  try {
    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return "";

    // Weekday, day, month, year
    const weekday = new Intl.DateTimeFormat("en-GB", { weekday: "long", timeZone }).format(dateObj);
    const day = new Intl.DateTimeFormat("en-GB", { day: "2-digit", timeZone }).format(dateObj);
    const monthName = new Intl.DateTimeFormat("en-GB", { month: "short", timeZone }).format(dateObj);
    const year = new Intl.DateTimeFormat("en-GB", { year: "numeric", timeZone }).format(dateObj);

    // Time in 12-hour format with AM/PM
    const time = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone,
    }).format(dateObj);

    return {
      date: `${weekday}, ${day} ${monthName} ${year}`,
      time, // e.g. "02:45 PM"
    };
  } catch (err) {
    console.error("Invalid date or timezone", err);
    return "";
  }
};




function getDelayStatusFromSeconds(delaySeconds) {
  if (delaySeconds === null || delaySeconds === undefined || delaySeconds === "") {
    return null; // leave completely
  }

  if (delaySeconds === 0) {
    return (
      <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
        On time
      </span>
    );
  }

  const absSeconds = Math.abs(delaySeconds);
  const hours = Math.floor(absSeconds / 3600);
  const minutes = Math.floor((absSeconds % 3600) / 60);

  let value = "";
  if (hours > 0) value += `${hours}hr `;
  if (minutes > 0) value += `${minutes}m`;

  if (delaySeconds > 0) {
    return (
      <span style={{ fontSize: "15px", color: "red", fontWeight: "600" }}>
        {value.trim()} Delay
      </span>
    );
  } else {
    return (
      <span style={{ fontSize: "15px", color: "green", fontWeight: "600" }}>
        {value.trim()} Early
      </span>
    );
  }
}


  function getPastTimeDiffReadable(utcDateString) {
    const target = moment.utc(utcDateString);
    const now = moment.utc();

    let diffMinutes = now.diff(target, "minutes");

    if (diffMinutes < 1) {
      return "Just now";
    }

    if (diffMinutes < 60) {
      return `${diffMinutes} minutes ago`;
    }

    let diffHours = now.diff(target, "hours");
    if (diffHours < 24) {
      return `${diffHours} hours ago`;
    }

    let diffDays = now.diff(target, "days");
    return `${diffDays} days ago`;
  }

  function getFlightStage( status) {
  
     // default grey

  

    return (
      <span
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          backgroundColor: "#2B9950",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "0.9rem",
        }}
      >
        {status}
      </span>
    );
  }

  function formatMinutesToHours(minutes) {
    if (minutes === null || minutes === undefined) return null;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}h ${m}m`;
  }

  function getFlightDuration(flightDurations, status) {
    if (!flightDurations || typeof flightDurations !== "object") return null;

    const { scheduledBlockMinutes, blockMinutes, airMinutes } = flightDurations;

    let minutes = null;

    if (status === "S" || status === "A") {
      // Scheduled or In Air
      minutes = scheduledBlockMinutes ?? airMinutes ?? null;
    } else if (status === "L") {
      // Landed
      minutes = blockMinutes ?? scheduledBlockMinutes ?? airMinutes ?? null;
    } else {
      // Fallback
      minutes = scheduledBlockMinutes ?? blockMinutes ?? airMinutes ?? null;
    }

    return formatMinutesToHours(minutes);
  }

  return (
    <div>
      <Nav />
      <div className="historic-wrapper">
        <div className="historic-container">
          <div className="historic-header">
            <h2>Flight Live Tracking</h2>
            {/* <Link to={"/check-weather"} className="check-weather-link">
              {" "}
              <IconTemperatureSun /> Check Airport Weather Status
            </Link> */}
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
             <div className="grid-two" style={{marginBottom:"20px"}}>
                                <div className="custom-input">
            
                                    <label className="input-label">
                                    Search by
                                    {/* <span style={{ color: "#de8385" }}> *</span> */}
                                  </label>
            
                                    <Radio.Group
                                                                    value={searchBy}
                                                      onChange={(value) => {
                                                                                    
                            
                                                       setSearchBy(value)
                                                                                  }}
                                                                >
                                      <div className="claim-form-radio-wrapper">
                                        
                                                                    <Radio
                                                                      color="red"
                                                                      // checked
                                                                      variant="outline"
                                                                      value={"airline_name"}
                                          label="Airline name"
                                          size="xs"
                                                        />
                                                        
                                                                    <Radio
                                                                      color="red"
                                                                      variant="outline"
                                                                      value={"iata_code"}
                                          label="Airline code"
                                          size="xs"
                                          
                                                                    />
                                                                  </div>
                                                                </Radio.Group>
                                </div>
                                
            
                              
            
                               
                              </div>
            <div className="grid-three">
              <div className="custom-select" style={{ width: "100%" }}>
                 {/* <div className="airline-radio-wrapper">
                                
                                                        <Radio.Group
                                                                                      value={searchBy}
                                                          onChange={(value) => {
                                                                                        
                                
                                                           setSearchBy(value)
                                                                                      }}
                                                                                    >
                                                          <div className="claim-form-radio-wrapper">
                                                            <label className="search-by-label">Search by:</label>
                                                                                        <Radio
                                                                                          color="red"
                                                                                          // checked
                                                                                          variant="outline"
                                                                                          value={"airline_name"}
                                                              label="Airline name"
                                                              size="xs"
                                                                            />
                                                                            
                                                                                        <Radio
                                                                                          color="red"
                                                                                          variant="outline"
                                                                                          value={"iata_code"}
                                                              label="Airline code"
                                                              size="xs"
                                                              
                                                                                        />
                                                                                      </div>
                                                                                    </Radio.Group>
                                                      </div> */}
                <span className="select-label">
                  Airline <span style={{ color: "#de8385" }}> *</span>
                </span>
                <div
                  className="select-box"
                  style={{
                    borderColor: "#E6F6FF",
                    backgroundColor: "#e8eef7",
                  }}
                >
                  <Controller
                    control={control}
                    name="airline"
                    rules={{ required: "Airline is required" }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions={false}
                        defaultOptions={defaultAirlineOptions}
                        loadOptions={loadAirlineOptions}
                        value={field.value}
                        onChange={field.onChange}
                        placeholder="Search airline"
                        styles={selectStyles}
                      />
                    )}
                  />
                </div>
                {errors.airline && (
                  <p className="errormessage">{errors.airline.message}</p>
                )}
              </div>

              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Flight number
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="flightNumber"
                  control={control}
                  rules={{
                    required: "Flight Number is Required",
                    validate: (value) => {
                      if (!/^[a-zA-Z0-9]+$/.test(value)) {
                        return "Only letters and numbers are allowed";
                      }
                      if (value.length > 10) {
                        // Change to 7 if needed
                        return "Maximum 10 characters allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter flight number"
                      type="text"
                      maxLength={10}
                      onChange={(e) => {
                        const cleanedValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        field.onChange(cleanedValue);
                      }}
                    />
                  )}
                />
                {errors.flightNumber && (
                  <p className="errormessage">{errors.flightNumber.message}</p>
                )}
              </div>

              <div className="custom-date-time-container">
                <label className="custom-date-time-label">
                  Scheduled departure date
                  <span style={{ color: "#de8385" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <div className="custom-date-time-box">
                    <Controller
                      name={`departureDate`}
                      control={control}
                      rules={{
                        required: "Departure Date is required",
                        validate: validateDateFormat,
                      }}
                      render={({ field }) => (
                        <CustomDOBPicker
                          {...field}
                          inputRequired={true}
                          placeholder="Choose date"
                          inputClassName="custom-date-input"
                          onChange={(value) => {
                            field.onChange(value);
                          }}
                        />
                      )}
                    />
                  </div>{" "}
                  {errors.departureDate && (
                    <p className="errormessage" style={{ marginTop: "12px" }}>
                      {errors.departureDate.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "40px",
              }}
            >
              <CustomButton btnText={"Submit"} style={{ width: "200px" }} />
            </div>
          </form>

          {loading && (
            <div className="loading-div">
              <Loader />
            </div>
          )}

          {!loading && !flightDetails && (
            <div
              className="no-data-found"
              style={{ marginTop: "40px", textAlign: "center" }}
            >
              <p>No flight data found</p>
            </div>
          )}

          {!loading && flightDetails && (
            <div
              className="flight-data-container"
              style={{ marginTop: "40px" }}
            >
              <h3 className="flight-data-header">Flight Data</h3>
              <div>
                <Tabs
                  defaultValue={upcomingDates[0]}
                  style={{ marginBottom: "20px" }}
                  value={activeTab}
                  onChange={handleChangeTab}
                  mt={"lg"}
                  styles={{
                    tabLabel: {
                      fontSize: "16px",
                    },

                    list: {
                      display: "flex",
                      flexWrap: "nowrap",
                      overflowX: "auto",
                      scrollbarWidth: "none",
                    },
                    tab: {
                      flex: "0 0 auto",
                    },
                    "list::-webkit-scrollbar": {
                      display: "none",
                    },
                  }}
                >
                  <Tabs.List
                    ref={tabsListRef}
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      scrollbarWidth: "none",
                      width: "100%", // Firefox
                    }}
                  >
                    {upcomingDates.map((date, index) => {
                      const isActive = activeTab === date;
                      return (
                        <Tabs.Tab
                          value={date}
                          key={index}
                          ref={isActive ? activeTabRef : null} // attach ref to active tab
                          style={{
                            fontSize: "16px",
                            borderBottom: isActive
                              ? "2px solid #228BE6"
                              : "1px solid transparent",
                            flexShrink: 0, // prevent shrinking in scroll
                          }}
                        >
                          {moment(date, "MM-DD-YYYY").format("ddd, DD MMM")}
                        </Tabs.Tab>
                      );
                    })}
                  </Tabs.List>
                </Tabs>
              </div>
              <div
                className="flight-data-wrapper"
                style={{ position: "relative" }}
              >
                <div className="flight-data-item" style={{justifyContent:"initial"}}>
                  <h4 className="text-left">
                    Departure <IconPlaneDeparture size={"24px"} />
                  </h4>
                  <div className="flight-data-item-details">
                    {
                      renderValue(flightDetails?.fromAirport?.code_iata) &&  <span className="iata-code text-left">
                      {flightDetails?.fromAirport?.code_iata}
                    </span>
                    }

                   
                   
                    {flightDetails?.fromAirport?.city &&  <span className="airport-country-name text-left">
                      {flightDetails?.fromAirport?.city}
                    </span> }
                   
                    {
                      flightDetails?.fromAirport?.name &&  <span className="airport-name text-left">
                       {flightDetails?.fromAirport?.name}
                    </span>
                    }
                   {flightDetails?.fromAirport?.gate && <span className="airport-terminal text-left">
                     
                        Gate {flightDetails?.fromAirport?.gate}
                    </span>}
{flightDetails?.fromAirport?.terminal && <span className="airport-terminal text-left">
                     
                        Terminal {flightDetails?.fromAirport?.terminal}
                    </span>}
                    
                  </div>

                  {
                    flightDetails?.fromAirport?.date &&  <div className="flight-data-item-date">
                    <span className="flight-date-track text-left">
                      {dateFormat(flightDetails?.fromAirport?.date,flightDetails?.fromAirport?.timezone).date}
                    </span>

                    <span className="flight-timezone text-left">
                      {dateFormat(flightDetails?.fromAirport?.date,flightDetails?.fromAirport?.timezone).time}{" "}
                      {getDelayStatusFromSeconds(
                        flightDetails?.fromAirport?.delay
                      )}
                    </span>

                      {
                       flightDetails?.fromAirport?.timezone && <span className="flight-timezone text-left">
                      {flightDetails?.fromAirport?.timezone}
                    </span>
                      }
                    
                  </div>
                  }
                 
                </div>

                <div className="flight-duration">
                  <span className="flight-number-wrapper">
                    {flightDetails?.flightNumber}
                  </span>

                  {getFlightStage(
                    
                    flightDetails?.status
                  )}
                </div>

                <div className="flight-data-item" style={{justifyContent:"initial"}}>
                  <h4
                    className="text-right"
                    style={{ justifyContent: "flex-end" }}
                  >
                    Arrival <IconPlaneArrival size={"24px"} />
                  </h4>

                  <div className="flight-data-item-details">

                    {flightDetails?.toAirport?.code_iata &&  <span className="iata-code text-right">
                      {flightDetails?.toAirport?.code_iata}
                    </span>}
                   
                    


                       {flightDetails?.toAirport?.city &&  <span className="airport-country-name text-right">
                      {flightDetails?.toAirport?.city}
                    </span> }
                    {
                      flightDetails?.toAirport?.name &&  <span className="airport-name text-right">
                       {flightDetails?.toAirport?.name}
                    </span>
                    }

                      {flightDetails?.toAirport?.gate && <span className="airport-terminal text-right">
                     
                        Gate {flightDetails?.toAirport?.gate}
                    </span>}
                  {flightDetails?.toAirport?.terminal && <span className="airport-terminal text-right">
                     
                        Terminal {flightDetails?.toAirport?.terminal}
                    </span>}
                  </div>

                  
                  {
                    flightDetails?.toAirport?.date &&
                    <div className="flight-data-item-date">
                      <span className="flight-date-track text-right">
                        {dateFormat(flightDetails?.toAirport?.date,flightDetails?.toAirport?.timezone).date}
                      </span>
                      <span
                        className="flight-timezone text-right mobile-timezone"
                        style={{ justifyContent: "flex-end" }}
                      >
                        {getDelayStatusFromSeconds(
                         flightDetails?.toAirport?.delay
                        )}{" "}
                        {dateFormat(flightDetails?.toAirport?.date,flightDetails?.toAirport?.timezone).time}{" "}
                      </span>
                    
                        
                          {
                       flightDetails?.toAirport?.timezone && <span  className="flight-timezone text-right mobile-timezone"
                        style={{ justifyContent: "flex-end" }}>
                      {flightDetails?.toAirport?.timezone}
                    </span>
                      }
                    </div>
                  

                  }
                </div>



                {
                  flightDetails?.progress && <div className="flight-line">

                  <div className="flight-line-duration">
                    <span style={{ background:flightDetails?.progress > 0 ? "#06a506":"#ccc" }}>

                      </span>
                      
                      {
                        flightDetails?.duration &&  <p className="flight-duration-box">{getFlightDurationHours(flightDetails.duration)}</p>
                      }
                     


                    <div className="green-line" style={{ position:"relative",width: `${flightDetails?.progress}%`, height: "4px", background: "#06a506" }}>
                     
                        <img src={FlightIcon} alt="flight-icon" style={{right: flightDetails?.progress === 0 ? "-20px":"-10px"}}/>
                        
                    
                    </div>

                     <span style={{ background:flightDetails?.progress === 100 ? "#06a506":"#ccc" }}>
                      
                    </span>
                    </div>
                    

                </div>
                }
                
                
                </div>


<div className="flight-data-refresh-wrapper">
                <span>
                  
              </span>

                {
                  flightDetails?.progress > 0 && flightDetails?.progress < 100 && <button
                    disabled={refreshing}
                    className="refresh-btn"
                    onClick={handleRefresh}
                    style={{outline:"none",border:"1px solid #ccc"}}
                >
                  <IconRotateClockwise size={"13px"} /> {refreshing?"Refreshing..":"Refresh"}
                </button>
                }
               
              </div>
              <div style={{display:"flex",justifyContent:"center"}}>
                             <img 
  src={`data:image/png;base64,${flightDetails?.map}`} 
  alt="preview" 
 className="map-view"
/>
                </div>
 
              

             


              {/* {
                flightDetails?.progress > 0 && flightDetails?.progress < 100 && <div className="flight-data-refresh-wrapper">
                 
                    <span className="last-updated">
                      Updated{" "}
                      {getPastTimeDiffReadable(positions?.at(-1)?.timestamp)}{" "}
                    </span>
                

                  <span
                    className="refresh-btn"
                    onClick={() => fetchFlightData(requestData)}
                  >
                    <IconRotateClockwise size={"13px"} /> Refresh
                  </span>
                </div>
                
              }
              <FlightMap
                airports={positions}
                currentFlightPosition={currentFlightPosition}
              
              /> */}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FlightLiveTracking;
